export const GET_DIVISION_RATE_WATCHER =
  "app/ReportsV2/WidgetResponseRateReport/GET_DIVISION_RATE_WATCHER"
export const GET_DIVISION_RATE_SUCCESS =
  "app/ReportsV2/WidgetResponseRateReport/GET_DIVISION_RATE_SUCCESS"
export const GET_DIVISION_RATE_FAILED =
  "app/ReportsV2/WidgetResponseRateReport/GET_DIVISION_RATE_FAILED"
